import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"
import FontAwesome from "react-fontawesome"
import ReactTooltip from "react-tooltip"
import { Instagram } from "styled-icons/fa-brands/Instagram"
import { Github } from "styled-icons/fa-brands/Github"
import { Twitter } from "styled-icons/fa-brands/Twitter"
import { MailOutline } from "styled-icons/material/MailOutline"

import { Link } from "gatsby"
import * as Styles from "./styles/sideBar"

import { rhythm } from "../utils/typography"
import "./styles/app.css"

const SideBar = ({ active }) => {
  const data = useStaticQuery(graphql`
    query BioQueryInSidebar {
      avatar: file(absolutePath: { regex: "/hero.jpg/" }) {
        childImageSharp {
          fixed(width: 150, height: 150) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      site {
        siteMetadata {
          author
          social {
            twitter
          }
        }
      }
    }
  `)
  let activeID = active

  // setTimeout(() => {
  //   console.log("path", window.location.pathname)
  //   const pathName = window.location.pathname
  //   switch (pathName) {
  //     case "/uses/":
  //       console.log(pathName)
  //       activeID = "uses"
  //       break
  //     case "/about":
  //       console.log(pathName)
  //       activeID = "about"
  //       break
  //   }
  //   console.log("fin", activeID)
  // }, 2000)

  const { author, social } = data.site.siteMetadata
  const socialGoTo = site => {
    if (site === "twitter") window.open("https://twitter.com/sagarhan_i")
    if (site === "github") window.open("https://github.com/sagarhani")
    if (site === "instagram") window.open("https://instagram.com/sagarhani")
    if (site === "email")
      window.open("mailto:sagarhani.in@gmail.com?subject=Hello Sagar")
  }

  return (
    <Styles.SideBarContainer>
      <Styles.ProfilePicture>
        <Link to={"/"}>
          <Styles.ImageWrapper>
            <Image
              fixed={data.avatar.childImageSharp.fixed}
              alt={author}
              style={{
                marginRight: rhythm(1 / 2),
                marginBottom: 45,
                minWidth: 120,
                minHeight: 120,
                borderRadius: `100%`,
              }}
              imgStyle={{
                borderRadius: `50%`,
              }}
            />
          </Styles.ImageWrapper>
        </Link>
      </Styles.ProfilePicture>
      <Styles.NavContainer>
        <ul>
          <Styles.NavItem id="about" active={activeID == "about"}>
            <Link to={"/about"}>About 👨🏻‍💻</Link>
          </Styles.NavItem>
          <Styles.NavItem id="notes" active={activeID == "notes"}>
            <Link to={"/cookies"}>Tech Cookies 🍪</Link>
          </Styles.NavItem>
          <Styles.NavItem id="blog" active={activeID == "blog"}>
            <Link to={"/blog"}>Blog 🧾</Link>
          </Styles.NavItem>

          {/* <Styles.NavItem id="recommendations">
            <Link to={"/recommendations"}>Recommendations 👌🏻</Link>
          </Styles.NavItem> 
          <Styles.NavItem id="uses" active={activeID == "uses"}>
            <Link to={"/uses"}>Uses 🛠</Link>
          </Styles.NavItem>*/}
        </ul>
      </Styles.NavContainer>
      <Styles.SocialContainer>
        <span data-tip="Twitter" onClick={e => socialGoTo("twitter")}>
          <Twitter color="white" size="22" />
        </span>
        <span data-tip="Github" onClick={e => socialGoTo("github")}>
          <Github size="24" color="white" />
        </span>
        <span data-tip="Instagram" onClick={e => socialGoTo("instagram")}>
          <Instagram size="24" color="white" />
        </span>
        <span data-tip="Email" onClick={e => socialGoTo("email")}>
          <MailOutline size="24" color="white" />
        </span>
        <ReactTooltip place="bottom" type="dark" effect="solid" />
      </Styles.SocialContainer>
    </Styles.SideBarContainer>
    // <div
    //   style={{
    //     display: `flex`,
    //     marginBottom: rhythm(2.5),
    //   }}
    // >
    //   <Image
    //     fixed={data.avatar.childImageSharp.fixed}
    //     alt={author}
    //     style={{
    //       marginRight: rhythm(1 / 2),
    //       marginBottom: 0,
    //       minWidth: 50,
    //       borderRadius: `100%`,
    //     }}
    //     imgStyle={{
    //       borderRadius: `50%`,
    //     }}
    //   />
    //   <p>
    //     Written by <strong>{author}</strong> who lives and works in San
    //     Francisco building useful things.
    //     {` `}
    //     <a href={`https://twitter.com/${social.twitter}`}>
    //       You should follow him on Twitter
    //     </a>
    //   </p>
    // </div>
  )
}

export default React.memo(SideBar)
